/*
 * Slim v4.19.0 - Image Cropping Made Easy
 * Copyright (c) 2018 Rik Schennink - http://slimimagecropper.com
 */
<template>
    <div class="slim">
        <slot></slot>
    </div>
</template>

<script>
// Slim (place slim CSS and slim.module.js file in same folder as this file)
import Slim from './slim.module.js';

let instance = null;

export default {
  props: ['options', 'data'],
  name: 'slim-cropper',
  mounted() {
    instance = new Slim(this.$el, this.options);
    if (this.data) {
      instance.load(this.data);
    }
  },
  beforeDestroy() {
    console.log('instance.destroy()');
    instance.destroy();
  },
  methods: {
  },
};
</script>
<style lang="css">
    @import "./slim.min.css";
</style>



// WEBPACK FOOTER //
// src/components/slim.vue